import { useCreateOrUpdatePhotographyInBibliography } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FieldConfig } from "@/config/forms/general";
import { PhotographyInBibliography } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const PhotographyInBibliographyDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: PhotographyInBibliography;
  queryId: string;
  type: LinkableType;
}) => {
  const schema = z.object({
    photographiesDansBibliographieDescriptionReproduitPage: z
      .string()
      .optional(),
    photographiesDansBibliographieDescriptionCitePage: z.string().optional(),
    photographiesDansBibliographieDescriptionPhotographe: z.string().optional(),
    photographiesDansBibliographieDescriptionReproductionCouleur: z
      .boolean()
      .optional(),
    photographiesDansBibliographieDescriptionNonPagine: z.boolean().optional(),
    bibliography: z.object({
      bibliographieDescriptionNumeroBibliographie: z.string().optional(),
      bibliographieDescriptionResumeLong: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdatePhotographyInBibliography } =
    useCreateOrUpdatePhotographyInBibliography(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      bibliography: data.bibliography,
      photographiesDansBibliographieDescriptionReproduitPage:
        data.photographiesDansBibliographieDescriptionReproduitPage,
      photographiesDansBibliographieDescriptionCitePage:
        data.photographiesDansBibliographieDescriptionCitePage,
      photographiesDansBibliographieDescriptionPhotographe:
        data.photographiesDansBibliographieDescriptionPhotographe,
      photographiesDansBibliographieDescriptionReproductionCouleur:
        data.photographiesDansBibliographieDescriptionReproductionCouleur,
      photographiesDansBibliographieDescriptionNonPagine:
        data.photographiesDansBibliographieDescriptionNonPagine,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdatePhotographyInBibliography({
      id: data.id,
      photographyId: data.photography.id,
      bibliographyId: data.bibliography.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default PhotographyInBibliographyDrawer;
